<div class="css-ymwz53">
  <div class="css-b5x8ma">

    <div class="title-block">
      <h1 class="css-1ihths2">Liste des produits</h1>
    </div>
    <!--    {{this.productsList}}-->

    <div class="row-fluid css-yhfnbu" style="padding-left: 24px;padding-top: 24px;">
      <div *ngFor="let product of productsList" class="col css-j4ovin">
        <div class="css-tzs92q">
          <div class="css-ztw7uw">
            <div class="css-exdp1c">
              <div class="css-1mh3kev"><h3 class="css-16d7giq">{{product.name}}</h3></div>
              <div class="css-yssrhh"><p class="css-ao">{{product.description}}</p></div>
            </div>
          </div>
          <div class="css-1w6ph7q">
            <div class="css-xoygyv"><h1 class="css-ytld2i">{{product.price}} €</h1><h4 class="css-5cbxen">HT</h4>
            </div>
          </div>
          <div class="css-1em2eu3"></div>
          <div class="css-ztw7uw">
            <div class="css-9gymlj">
              <ul style="list-style-type: initial; height: 44px;padding: 0;">
                <li style="position: relative; height: 22px;"><p class="css-1ykazfi">{{product.certifications[0]}}</p>
                </li>
                <li style="position: relative; height: 22px;"><p class="css-1ykazfi">{{product.certifications[1]}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="css-1w6ph7q">
            <div class="css-xoygyv"><h1 class="css-ytld2i">{{ product.duration | pluralizeYear }}</h1></div>
          </div>
          <div class="css-1em2eu3"></div>
          <div class="css-1w6ph7q">
            <div class="css-0">
              <div class="css-s8g5we">
                <button class="btn-bleu" tabindex="0" type="button" (click)="finalizeOrder(product)">Commander</button>
              </div>

              <div class="css-213cs">
                <button class="css-hmseq5" tabindex="0" type="button" (click)="productDetail(product)">En savoir plus<span class="css-pt151d">
                  <mat-icon>arrow_forward</mat-icon></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="row-fluid css-yhfnbu" style="padding-left: 24px;padding-top: 24px;">-->
    <!--      <div class="col css-j4ovin">-->
    <!--        <div class="css-tzs92q">-->
    <!--          <div class="css-ztw7uw">-->
    <!--            <div class="css-exdp1c">-->
    <!--              <div class="css-1mh3kev"><h3 class="css-16d7giq">Décideur - G2 - 1 an</h3></div>-->
    <!--              <div class="css-yssrhh"><p class="MuiTypography-root MuiTypography-body1 css-ao">Appels d’offres</p></div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-xoygyv"><h1 class="MuiTypography-root MuiTypography-h1 css-ytld2i">110 €</h1><h4 class="MuiTypography-root MuiTypography-h4 css-5cbxen">HT</h4></div>-->
    <!--          </div>-->
    <!--          <div class="css-1em2eu3"></div>-->
    <!--          <div class="css-ztw7uw">-->
    <!--            <div class="css-9gymlj">-->
    <!--              <ul style="list-style-type: initial; height: 44px;padding: 0;">-->
    <!--                <li style="position: relative; height: 22px;"><p class="MuiTypography-root MuiTypography-body2 css-1ykazfi">Certificat de signature qualifié eIDAS</p></li>-->
    <!--                <li style="position: relative; height: 22px;"><p class="MuiTypography-root MuiTypography-body2 css-1ykazfi">Certification ETSI 319 411-1 niveau NCP+ (certificat d’authentification)</p></li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-xoygyv"><h1 class="MuiTypography-root MuiTypography-h1 css-ytld2i">1 an</h1></div>-->
    <!--          </div>-->
    <!--          <div class="css-1em2eu3"></div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-0">-->
    <!--              <div class="css-s8g5we">-->
    <!--                <button class="btn-bleu" tabindex="0" type="button" (click)="finalizeOrder('decideur1')">Commander</button>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col css-j4ovin">-->
    <!--        <div class="css-tzs92q">-->
    <!--          <div class="css-ztw7uw">-->
    <!--            <div class="css-exdp1c">-->
    <!--              <div class="css-1mh3kev"><h3 class="css-16d7giq">Décideur - G2 - 2 ans</h3></div>-->
    <!--              <div class="css-yssrhh"><p class="MuiTypography-root MuiTypography-body1 css-ao">Appels d’offres</p></div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-xoygyv"><h1 class="MuiTypography-root MuiTypography-h1 css-ytld2i">180 €</h1><h4 class="MuiTypography-root MuiTypography-h4 css-5cbxen">HT</h4></div>-->
    <!--          </div>-->
    <!--          <div class="css-1em2eu3"></div>-->
    <!--          <div class="css-ztw7uw">-->
    <!--            <div class="css-9gymlj">-->
    <!--              <ul style="list-style-type: initial; height: 44px;padding: 0;">-->
    <!--                <li style="position: relative; height: 22px;"><p class="MuiTypography-root MuiTypography-body2 css-1ykazfi">Certificat de signature qualifié eIDAS</p></li>-->
    <!--                <li style="position: relative; height: 22px;"><p class="MuiTypography-root MuiTypography-body2 css-1ykazfi">Certification ETSI 319 411-1 niveau NCP+ (certificat d’authentification)</p></li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-xoygyv"><h1 class="MuiTypography-root MuiTypography-h1 css-ytld2i">2 ans</h1></div>-->
    <!--          </div>-->
    <!--          <div class="css-1em2eu3"></div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-0">-->
    <!--              <div class="css-s8g5we">-->
    <!--                <button class="btn-bleu" tabindex="0" type="button" (click)="finalizeOrder('decideur2')">Commander</button>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col css-j4ovin">-->
    <!--        <div class="css-tzs92q">-->
    <!--          <div class="css-ztw7uw">-->
    <!--            <div class="css-exdp1c">-->
    <!--              <div class="css-1mh3kev"><h3 class="css-16d7giq">Décideur - G2 - 3 ans</h3></div>-->
    <!--              <div class="css-yssrhh"><p class="MuiTypography-root MuiTypography-body1 css-ao">Appels d’offres</p></div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-xoygyv"><h1 class="MuiTypography-root MuiTypography-h1 css-ytld2i">255 €</h1><h4 class="MuiTypography-root MuiTypography-h4 css-5cbxen">HT</h4></div>-->
    <!--          </div>-->
    <!--          <div class="css-1em2eu3"></div>-->
    <!--          <div class="css-ztw7uw">-->
    <!--            <div class="css-9gymlj">-->
    <!--              <ul style="list-style-type: initial; height: 44px;padding: 0;">-->
    <!--                <li style="position: relative; height: 22px;"><p class="MuiTypography-root MuiTypography-body2 css-1ykazfi">Certificat de signature qualifié eIDAS</p></li>-->
    <!--                <li style="position: relative; height: 22px;"><p class="MuiTypography-root MuiTypography-body2 css-1ykazfi">Certification ETSI 319 411-1 niveau NCP+ (certificat d’authentification)</p></li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-xoygyv"><h1 class="MuiTypography-root MuiTypography-h1 css-ytld2i">3 ans</h1></div>-->
    <!--          </div>-->
    <!--          <div class="css-1em2eu3"></div>-->
    <!--          <div class="css-1w6ph7q">-->
    <!--            <div class="css-0">-->
    <!--              <div class="css-s8g5we">-->
    <!--                <button class="btn-bleu" tabindex="0" type="button" (click)="finalizeOrder('decideur3')">Commander</button>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</div>
